import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUpRounded";
import { generatePath, useMatch } from "react-router";
import useClientContext from "../../context/useClientContext";
import useInvestorRelationsAccess from "../../hooks/useInvestorRelationsAccess";
import { pageRoutes } from "../../routes";
import MenuLinkItem from "../common/MenuLinkItem";
import SubMenuList from "./SubMenuList";

const InvestorRelationsMenu = () => {
  const { clientCode, menuBadges, investorPortalApp } = useClientContext();

  const {
    hasAccessToFundStructure,
    hasAccessToInvestorEmails,
    hasAccessToInvestorPortalSettings,
    hasAccessToInvestorRequests,
    hasAccessToDocumentCollections,
    hasAccessToDocumentActivity,
    hasAccessToFundraising,
    hasAccessToInvestorCommunications,
  } = useInvestorRelationsAccess();

  const routePattern = `/:clientCode/${pageRoutes.investorRelations}/:page/*`;
  const routeMatch = useMatch(routePattern);
  const currentPage = routeMatch?.params["page"];

  const buildFullPath = (page: string) => generatePath(routePattern, { clientCode, page });

  return (
    <SubMenuList>
      {hasAccessToFundStructure && (
        <MenuLinkItem
          subItem
          active={currentPage === pageRoutes.funds}
          title="Funds"
          href={buildFullPath(pageRoutes.funds)}
        />
      )}
      {hasAccessToFundStructure && (
        <MenuLinkItem
          subItem
          active={currentPage === pageRoutes.investors}
          title="Investors"
          href={buildFullPath(pageRoutes.investors)}
        />
      )}
      {hasAccessToFundStructure && (
        <MenuLinkItem
          subItem
          active={currentPage === pageRoutes.contacts}
          title="Contacts"
          href={buildFullPath(pageRoutes.contacts)}
        />
      )}
      {hasAccessToInvestorRequests && investorPortalApp && (
        <MenuLinkItem
          subItem
          active={currentPage === pageRoutes.requests}
          title="Requests"
          href={buildFullPath(pageRoutes.requests)}
          badgeCount={menuBadges?.pendingInvestorChangeRequestCount}
        />
      )}
      {hasAccessToDocumentCollections && (
        <MenuLinkItem
          subItem
          active={currentPage === pageRoutes.documentCollections}
          title="Document Collections"
          href={buildFullPath(pageRoutes.documentCollections)}
        />
      )}
      {hasAccessToInvestorCommunications && (
        <MenuLinkItem
          subItem
          active={currentPage === pageRoutes.investorCommunications}
          title="Investor Communications"
          href={buildFullPath(pageRoutes.investorCommunications)}
        />
      )}
      {hasAccessToFundraising && (
        <MenuLinkItem
          subItem
          active={currentPage === pageRoutes.fundraisings}
          title="Fundraising"
          href={buildFullPath(pageRoutes.fundraisings)}
        />
      )}
      {hasAccessToDocumentActivity && investorPortalApp && (
        <MenuLinkItem
          subItem
          active={currentPage === pageRoutes.documentActivity}
          title="Document Activity"
          href={buildFullPath(pageRoutes.documentActivity)}
        />
      )}
      {hasAccessToInvestorEmails && (
        <MenuLinkItem
          subItem
          active={currentPage === pageRoutes.investorEmails}
          title="Email Delivery Log"
          href={buildFullPath(pageRoutes.investorEmails)}
        />
      )}
      {hasAccessToInvestorPortalSettings && (
        <MenuLinkItem
          subItem
          active={currentPage === pageRoutes.accessCategories}
          title="Access Categories"
          href={buildFullPath(pageRoutes.accessCategories)}
        />
      )}
      {hasAccessToInvestorPortalSettings && investorPortalApp && (
        <MenuLinkItem
          subItem
          active={currentPage === pageRoutes.investorPortalSettings}
          title="Investor Portal"
          href={buildFullPath(pageRoutes.investorPortalSettings)}
        />
      )}
      {!investorPortalApp && (
        <MenuLinkItem
          subItem
          active={currentPage === pageRoutes.aboutInvestorPortal}
          title="Investor Portal"
          href={buildFullPath(pageRoutes.aboutInvestorPortal)}
          EndIcon={ArrowCircleUpIcon}
        />
      )}
    </SubMenuList>
  );
};

export default InvestorRelationsMenu;
